<script>
    import { cn } from "~/utils";
</script>

<div class={cn("px-6 sm:px-8", $$restProps.class)}>
    <slot />
</div>
